import React from "react";
import { Card, CardContent } from "../ui/card";
import { BehaviorEntry } from "../../types/tradingJournal";
import {
  CheckCircleIcon,
  AlertTriangleIcon,
  BadgeInfoIcon,
} from "lucide-react";
import { useTradeJournal } from "../../context/TradeJournalContext";

interface BehaviorMetricsCardsProps {
  filteredBehaviorEntries: BehaviorEntry[];
}

const BehaviorMetricsCards = ({
  filteredBehaviorEntries,
}: BehaviorMetricsCardsProps) => {
  const { stats } = useTradeJournal();

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Card className="intellectia-card bg-white/5">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-white/60 text-sm mb-1">Plan Adherence</p>
              <p className="text-2xl font-bold text-white">
                {filteredBehaviorEntries.length > 0
                  ? (
                      (filteredBehaviorEntries.filter(
                        (e) => e.followedPlan === "Yes"
                      ).length /
                        filteredBehaviorEntries.length) *
                      100
                    ).toFixed(1)
                  : "0.0"}
                %
              </p>
            </div>
            <div className="p-3 rounded-full bg-white/10">
              <CheckCircleIcon className="h-6 w-6 text-white" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="intellectia-card bg-white/5">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-white/60 text-sm mb-1">Emotional Trading</p>
              <p className="text-2xl font-bold text-yellow-400">
                {filteredBehaviorEntries.length > 0
                  ? (
                      (filteredBehaviorEntries.filter(
                        (e) => e.emotionallyCalm === "No"
                      ).length /
                        filteredBehaviorEntries.length) *
                      100
                    ).toFixed(1)
                  : "0.0"}
                %
              </p>
            </div>
            <div className="p-3 rounded-full bg-yellow-400/10">
              <AlertTriangleIcon className="h-6 w-6 text-yellow-400" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="intellectia-card bg-white/5">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-white/60 text-sm mb-1">Setup vs. Instinct</p>
              <p className="text-2xl font-bold text-blue-400">
                {filteredBehaviorEntries.length > 0
                  ? (
                      (filteredBehaviorEntries.filter(
                        (e) => e.tradedOnSetup === "Setup"
                      ).length /
                        filteredBehaviorEntries.length) *
                      100
                    ).toFixed(1)
                  : "0.0"}
                % Setup
              </p>
            </div>
            <div className="p-3 rounded-full bg-blue-400/10">
              <BadgeInfoIcon className="h-6 w-6 text-blue-400" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BehaviorMetricsCards;
